import { render, staticRenderFns } from "./VFieldTextarea.vue?vue&type=template&id=8025137c&"
import script from "./VFieldTextarea.vue?vue&type=script&lang=js&"
export * from "./VFieldTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8025137c')) {
      api.createRecord('8025137c', component.options)
    } else {
      api.reload('8025137c', component.options)
    }
    module.hot.accept("./VFieldTextarea.vue?vue&type=template&id=8025137c&", function () {
      api.rerender('8025137c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VForm/VFieldTextarea.vue"
export default component.exports